import './styles.scss';

import Button from '@/common/Button';
import CompleteEvaluationWizard from '@/pages/Users/components/CompleteEvaluationWizard';
import { TrainingChecklistTableTypes } from '../TrainingChecklistTable/types';
import { User } from '@/models/gen/graphql';
import { useState } from 'react';
import useTrainingChecklistTableState from '../TrainingChecklistTable/hook';

export type CompleteEvaluationButtonProps = {
  user?: User;
};

const CompleteEvaluationButton = ({ user }: CompleteEvaluationButtonProps) => {
  const categoriesCompleted = useTrainingChecklistTableState(({ state }) =>
    state.rows.every((row) => row.status === TrainingChecklistTableTypes.CategoryStatus.COMPLETED)
  );
  const totalAttempts = useTrainingChecklistTableState(({ state }) => state.totalAttempts);
  const [showWizard, setShowWizard] = useState(false);

  return (
    <div className="CompleteEvaluationButton">
      <div>Attempts: {totalAttempts}</div>
      <Button variant="primary" disabled={!categoriesCompleted} onClick={(): void => setShowWizard(true)}>
        Complete Evaluation
      </Button>
      <CompleteEvaluationWizard
        show={showWizard}
        userId={user?.id || ''}
        userFullName={`${user?.firstName || ''} ${user?.lastName || ''}`.trim()}
        userEmployeeId={user?.employeeId || ''}
        userRoleName={user?.role?.name || ''}
        onHide={(): void => setShowWizard(false)}
      />
    </div>
  );
};

export default CompleteEvaluationButton;
